import { IOnboardingDocuments } from '@efex-services/documents/documentsSvc';
import { StakeHolderId } from '@pages/onboarding/Mexico/constants/stakeHolderOptions';
import { createContext } from 'react';
import { DeleteGovernmentIdDocument } from './reducers/govermentIdReducer/types';

interface StakeHolderContextProps {
  personType: number;
  setPersonType: (personType: number) => void;
  businessSectorId: ICompanySector | null | undefined;
  setBusinessSectorId: (
    businessSectorId: ICompanySector | null | undefined
  ) => void;
  govermentIdDocuments: {
    documentOne: IOnboardingDocuments | null;
    documentTwo: IOnboardingDocuments | null;
  };
  setGovermentIdDocuments: (data: IOnboardingDocuments[]) => void;
  handleChangeTypeOfGovernmentId: () => void;
  deleteGovernmentIdDocument: (
    documentPlace: DeleteGovernmentIdDocument
  ) => void;
  changeDocument: (e: React.ChangeEvent<HTMLInputElement>) => void;
  deleteDocumensToDelete: () => Promise<void>;
  proofOfAddressDocument: IOnboardingDocuments[];
  setProofOfAddressDocument: (data: IOnboardingDocuments[]) => void;
  changeProofOfAddressDocument: (
    e: React.ChangeEvent<HTMLInputElement>
  ) => void;
  deleteProofOfAddressDocument: () => void;
  getAllCurrentDocumentsIds: () => number[];
  handleDropChangeDocument: (e: FileList, inputName: string) => void;
}

export default createContext<StakeHolderContextProps>({
  personType: StakeHolderId.NATURAL_MX,
  setPersonType: () => {},
  businessSectorId: null,
  setBusinessSectorId: () => {},
  govermentIdDocuments: {
    documentOne: null,
    documentTwo: null,
  },
  setGovermentIdDocuments: () => {},
  handleChangeTypeOfGovernmentId: () => {},
  deleteGovernmentIdDocument: () => {},
  changeDocument: () => {},
  deleteDocumensToDelete: () => Promise.resolve(),
  proofOfAddressDocument: [],
  setProofOfAddressDocument: () => {},
  changeProofOfAddressDocument: () => {},
  deleteProofOfAddressDocument: () => {},
  getAllCurrentDocumentsIds: () => [],
  handleDropChangeDocument: () => {},
});
